import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import MobileFrame from "@/components/MobileFrame";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NewInspection from "@/pages/NewInspection";
import Checklist from "@/pages/Checklist";
import Evidence from "@/pages/Evidence";
import Settings from "@/pages/Settings";

function ProtectedRoute({ children }) {
  const { user } = useApp();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnlyRoute({ children }) {
  const { user } = useApp();
  if (user) return <Navigate to="/" replace />;
  return children;
}

function ThemedToaster() {
  const { theme } = useApp();
  return (
    <Toaster
      theme={theme === "dark" ? "dark" : "light"}
      position="top-center"
      toastOptions={{ className: "font-mono-tech" }}
    />
  );
}

export default function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<MobileFrame />}>
              <Route
                path="/login"
                element={
                  <PublicOnlyRoute>
                    <Login />
                  </PublicOnlyRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/new"
                element={
                  <ProtectedRoute>
                    <NewInspection />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/checklist/:partId"
                element={
                  <ProtectedRoute>
                    <Checklist />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/evidence/:id"
                element={
                  <ProtectedRoute>
                    <Evidence />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <ProtectedRoute>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <ThemedToaster />
      </AppProvider>
    </div>
  );
}
